import { DateInput as MantineDateInput } from '@mantine/dates'
import type { UseFormRegisterReturn } from 'react-hook-form'

interface DateInputProps {
  label: string
  placeholder?: string
  required?: boolean
  error?: string
  helperText?: string
  className?: string
  disabled?: boolean
  register?: UseFormRegisterReturn
  value?: Date | null
  onChange?: (value: Date | null) => void
  minDate?: Date
  maxDate?: Date
  clearable?: boolean
}

export function DateInput({
  label,
  placeholder,
  required = false,
  error,
  helperText,
  className = '',
  disabled = false,
  register,
  value,
  onChange,
  minDate,
  maxDate,
  clearable = true,
}: DateInputProps) {
  const dateProps = register
    ? {
        ...register,
        onChange: (value: string | null) => {
          register.onChange({ target: { value: value || '' } })
        },
      }
    : {
        value,
        onChange: (value: string | null) => {
          // Convert string to Date for the onChange callback
          const dateValue = value ? new Date(value) : null
          onChange?.(dateValue)
        },
      }

  return (
    <div className={`space-y-1 ${className}`}>
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>

      <MantineDateInput
        {...dateProps}
        placeholder={placeholder}
        disabled={disabled}
        error={error}
        description={helperText}
        radius="md"
        size="md"
        className="w-full"
        minDate={minDate}
        maxDate={maxDate}
        clearable={clearable}
        valueFormat="DD/MM/YYYY"
        popoverProps={{
          floatingStrategy: 'fixed',
          zIndex: 400,
        }}
        styles={{
          input: {
            backgroundColor: '#F5F5F7',
            border: 'none',
          },
          error: {
            fontSize: 10,
            marginTop: 0,
          },
        }}
      />
    </div>
  )
}
